import { render, staticRenderFns } from "./market-analysis-product.page.vue?vue&type=template&id=1651e61f&scoped=true"
import script from "./market-analysis-product.page.vue?vue&type=script&lang=ts"
export * from "./market-analysis-product.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1651e61f",
  null
  
)

export default component.exports